import { render } from "./SvgIcon.vue?vue&type=template&id=5f6ac2de"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=5f6ac2de&lang=scss"

import exportComponent from "D:\\如峰\\浮雲客棧webapp 前後台系統\\前台\\kloudmobileweb\\KloudMobileWeb\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__